export default __webpack_public_path__ + "static/media/googlesamlguide.7be5c3d7.png";